export const autoApplyVoucherTracking = {
  EVENT_CATEGORY: 'buttonTap',
  ADDED_EVENT_ACTION: 'Applicable_coupon_auto_applied',
  ADDED_EVENT_LABEL: 'best coupon auto applied',
  REMOVED_EVENT_ACTION: 'Applicable_coupon_auto_apply_removed',
  REMOVED_EVENT_LABEL: 'best coupon auto apply removed',
  VOUCHER_APPLIED_MESSAGE_TIMEOUT: 20000
};
